import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
    0% {
        transform: scale(1);
        box-shadow: 0 0 0 0 ${({ theme }) => theme.colors.theme.warning};
    }
    
    50% {
        transform: scale(1.1);
        box-shadow: 0 0 0 4px ${({ theme }) => `${theme.colors.theme.warning}40`};
    }
    
    100% {
        transform: scale(1);
        box-shadow: 0 0 0 0 ${({ theme }) => theme.colors.theme.warning};
    }
`;

export const NotificationCircle = styled.div`
    position: fixed;
    bottom: 15px;
    right: 20px;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.theme?.contentBg};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.20);
    backdrop-filter: blur(8px); 
    z-index: 1000;
`;

export const PulsingDot = styled.div`
    position: absolute;
    right: 5px;
    top: 5px;
    width: 6px;
    height: 6px;
    background-color: ${({ theme }) => theme.colors.theme.warning};
    border-radius: 50%;
    animation: ${pulse} 1.5s ease-in-out infinite;
`;

export const CardContainer = styled.div<{ $isVisible: boolean }>`
    position: fixed;
    bottom: 80px;
    right: 20px;
    display: ${({ $isVisible }) => ($isVisible ? 'block' : 'none')};
    z-index: 1000;

`;